import React from "react";
import { Flex } from "antd";
import type { BusinessDTO } from "api";
import noImagePlaceholder from "src/assets/no-image-placeholder.webp";

import BusinessTagGift from "../BusinessTagGift";
import BusinessTagDiscount from "../BusinessTagDiscount";
import BusinessAddToFavoritesButton from "../BusinessAddToFavoritesButton";
import {
  BusinessAddress,
  BusinessCardContainer,
  BusinessCardContentContainer,
  BusinessCardTagsContainer,
  BusinessCardTextContainer,
  BusinessTitle,
} from "./BusinessCard.styles";

export interface BusinessCardProps {
  business: BusinessDTO;
}

const BusinessCard: React.FC<BusinessCardProps> = ({ business: { name, address, logoUrl } }) => {
  return (
    <BusinessCardContainer
      hoverable
      cover={
        <>
          <img alt={name} src={logoUrl ?? noImagePlaceholder} />
          <BusinessCardTagsContainer wrap>
            <BusinessTagDiscount />
            <BusinessTagGift />
          </BusinessCardTagsContainer>
        </>
      }
    >
      <BusinessCardContentContainer>
        <BusinessCardTextContainer vertical>
          <BusinessTitle>{name}</BusinessTitle>
          <BusinessAddress type="secondary" ellipsis>
            {address || "No address specified"}
          </BusinessAddress>
        </BusinessCardTextContainer>
        <Flex>
          <BusinessAddToFavoritesButton isFavorite onClick={() => {}} />
        </Flex>
      </BusinessCardContentContainer>
    </BusinessCardContainer>
  );
};

export default BusinessCard;
